export function memoizeOnce<I, O>(output: (input: I) => O): (input: I) => O {
  let prevInput: I | undefined;
  let prevOutput: O | undefined;
  return (i) => {
    if (i !== prevInput) {
      prevInput = i;
      prevOutput = output(i);
    }
    return prevOutput!;
  };
}

export function memoizeDependencies<O>(
  output: () => O,
  getDependencies: () => unknown[]
): () => O {
  let prevDependencies: unknown[] = [];
  let prevOutput: O | undefined = undefined;
  let prevOutputSet = false;
  return () => {
    let dependencies = getDependencies();
    if (!prevOutputSet) {
      prevDependencies = dependencies;
      prevOutput = output();
      prevOutputSet = true;
      return prevOutput;
    }
    for (let i in prevDependencies) {
      if (dependencies[i] !== prevDependencies[i]) {
        prevDependencies = dependencies;
        prevOutput = output();
        break;
      }
    }
    return prevOutput!;
  };
}
